if (!customElements.get("product-select")) {
  class ProductSelect extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", this.onVariantChange);
    }
    onVariantChange({ target }) {
      const sectionId = this.dataset.sectionId;
      this.disableAddButton();
      fetch(`${this.dataset.url}?variant=${target.value}&section_id=${sectionId}`).then((response) => response.text()).then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.innerHTML = html.querySelector(`.shopify-section`).innerHTML;
      }).catch((error) => {
        console.error("An error occurred in the function onSelectChange", error);
      });
    }
    disableAddButton() {
      const addButton = this.querySelector('button[name="add"]');
      addButton.setAttribute("disabled", true);
    }
  }
  customElements.define("product-select", ProductSelect);
}
